module.exports = __webpack_public_path__ + "static/media/TruthSeekers_Logo.3cf3e438.png";